import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalHeader,
  ModalBody,
  Text,
  Heading,
  Flex
} from '@chakra-ui/react';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { states, districts } from '../../data';

export const ContactModal = ({ isOpen, onClose, contactId }) => {
  console.log(contactId);
  const [contact, setContact] = useState({});

  useEffect(() => {
    const getContact = async () => {
      try {
        const { data } = await axios.get(
          'https://bulk-messaging-server.herokuapp.com/contacts/get?contactId=' + contactId
        );
        setContact(data);
      } catch (error) {}
    };
    getContact();
  }, [contactId]);

  const state = states.states[Number(contact.state) - 1]?.stateName;
  const city = districts[contact.state]?.find(
    (m) => m['districtId'] === Number(contact.city)
  )?.districtName;

  return (
    <>
      <Modal
        size="full"
        isOpen={isOpen}
        onClose={onClose}
        isCentered
        blockScrollOnMount
        overflow="hidden">
        <ModalOverlay />
        <ModalContent m="0" h="100%">
          <ModalCloseButton />
          <ModalHeader>Contact Details</ModalHeader>
          <ModalBody>
            <Flex
              w="full"
              h="full"
              alignItems={'center'}
              justifyContent={'space-evenly'}
              flexDir={'column'}>
              <Heading size="md">{contact.name}</Heading>
              <Heading size="md">{contact.phone}</Heading>
              <Text>
                Lives at {contact.tag}, {city}, {state}
              </Text>
              <div style={{ width: 200, height: 200 }}>
                <CircularProgressbar
                  value={contact.consumption}
                  maxValue={10000}
                  text={`${contact.consumption}ltrs`}
                />
              </div>
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
